import React from "react";
import { RouteComponentProps, useParams, withRouter } from "react-router";


interface Params {
    fis_id: string;
    nombre: string;
    codigo: string;
    objetivo: string;
    ps_id: string;
}


const PanelFiscalizacion: React.FC<RouteComponentProps> = ({history}) => {

    const { ps_id, nombre, codigo,fis_id, objetivo } = useParams<Params>();

    const handleBack = () => {
        history.goBack();
    }

    return (
        <div className="fisCard">
            <div className="fisCard_title">
               
            </div>
            <div className="fisObj">
                <h5>Objetivo: {objetivo}</h5>
              
            </div>
            <div className="fisObj">
                <h5>{nombre}</h5>
              
            </div>
            <div className="fisVolver">
                <svg width="15" height="18" viewBox="0 0 15 18" fill="none">
                    <path d="M4.54895 4.9624L2.60449 6.62908L4.54895 8.57355" stroke="#404040" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M2.60449 6.62915H8.99177C10.9037 6.62915 12.5274 8.19028 12.6018 10.1014C12.6807 12.1209 11.0121 13.8514 8.99177 13.8514H4.27062" stroke="#404040" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <button onClick={handleBack}>Volver a areas</button>
            </div>
          
        </div>
    );
};

export default withRouter(PanelFiscalizacion);